<template>
    <div ref="containerDoBanner">
        <div v-if="completed" class="banner-sliced">
            <div v-for="(image, index) of imagesParsed" :key="index" >
                <a :href="image.link || ''" v-if="image.link">
                    <img :src="image.imageUrl" :style="{width: mobile ? '100%' : image.rWidth + 'px'}">
                </a>
                <a v-else>
                    <img :src="image.imageUrl" :style="{width: mobile ? '100%' : image.rWidth + 'px'}">
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'bannerSliced',
  props: {
      images:{
        type: Array,
      },
      mobile: {
          type: Boolean
      }
  },
  data() {
      return {
          completed: false,
          imagesParsed: [],
          containerWidth: 0
      }
  },
  methods: {
    rebuild() {
        var _bannerWidth = (banner, cbw) => {
            if(!banner) return cbw(0);
            var imgLoader = new Image();
            imgLoader.onload = function() {
                cbw(imgLoader.width);
            }
            imgLoader.src = banner.imageUrl;
        }
            
        var _rewidth = (i, maxWidth = 0, complete) => {
            _bannerWidth(this.images[i], (width) => {
                if(width == 0) {
                    complete();
                } else {
                    if(i == 0) {
                        this.imagesParsed = [];
                        this.imagesParsed.push({ ...this.images[i], rWidth: this.clientWidth });
                        maxWidth = width;
                        _rewidth((i+1), maxWidth, complete);
                    } else {
                        var _prop = width / maxWidth;
                        var ww = Math.floor(this.clientWidth * _prop);
                        this.imagesParsed.push({ ...this.images[i], rWidth: i == 3 ? this.imagesParsed[0].rWidth - this.imagesParsed[1].rWidth - this.imagesParsed[2].rWidth : ww });
                        _rewidth((i+1), maxWidth, complete);
                    }
                }
            })
        }
        this.imagesParsed = [];
        var wait = setInterval(() => {
            if(this.$refs.containerDoBanner) {
                clearInterval(wait);
                this.clientWidth = this.$refs.containerDoBanner.clientWidth;
                _rewidth(0, 0, () => {
                    this.completed = true;
                })
            }
        }, 200);
    }
  },
  components: {},
  created() {
    window.addEventListener('resize', () => {
        this.rebuild();
    });
    this.rebuild();
  }
}
</script>

<style scoped lang="scss">
    .banner-sliced > div > a {
        float: left;
        img {
            float: left;
            max-width: 100%;
        }
    }
</style>
